// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fNMr","col":"styles_col__2vj7y","actions":"styles_actions__u7vrq","conflict":"styles_conflict__27mVe"};